import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _get from 'lodash/get';
import _pick from 'lodash/pick';
import _isEmpty from 'lodash/isEmpty';
import _values from 'lodash/values';
import _compact from 'lodash/compact';
import _startCase from 'lodash/startCase';
import _memoize from 'lodash/memoize';
import _uniqBy from 'lodash/uniqBy';
import _map from 'lodash/map';
import _filter from 'lodash/filter';
import _isNumber from 'lodash/isNumber';
import _reduce from 'lodash/reduce';
import _find from 'lodash/find';
import _every from 'lodash/every';
import { getVehicleAgeInDays, isValidJob } from 'tbase/helpers/vehicle.helper';
import TEnvReader from 'tbase/readers/Env';
import { NO_DATA, EMPTY_STRING, EMPTY_ARRAY, EMPTY_OBJECT } from 'tbase/app.constants';
import { getNumber } from '../utils';
import { VEHICLE_TYPE } from '../constants/constants';
import { MILEAGE_TYPES, KM_TO_MILES_CONVERTOR_FACTOR } from '../constants/desking.constants';
export function getVehicleId(vehicle) {
  return _get(vehicle, 'id');
}
export var getMarketScanVehicleId = function getMarketScanVehicleId(vehicle) {
  return _get(vehicle, 'marketScanVehicleId');
};
export function getVin(vehicle) {
  return _get(vehicle, 'vin');
}
export var getChromeStyleId = function getChromeStyleId(vehicle) {
  return _get(vehicle, 'styleId');
};
export var getYearMakeModel = function getYearMakeModel(_ref) {
  var _ref$year = _ref.year,
      year = _ref$year === void 0 ? '' : _ref$year,
      _ref$make = _ref.make,
      make = _ref$make === void 0 ? '' : _ref$make,
      _ref$model = _ref.model,
      model = _ref$model === void 0 ? '' : _ref$model;
  return year || make || model ? "".concat(year, " ").concat(make, " ").concat(model) : EMPTY_STRING;
};
export function getOdometerReading(vehicle) {
  return _get(vehicle, 'mileage') || 0;
}
export var getRetailPrice = function getRetailPrice(vehicle) {
  return _get(vehicle, 'pricingDetails.retailPrice') || _get(vehicle, 'retailPrice') || 0;
};
export var getEntryTime = function getEntryTime(vehicle) {
  return _get(vehicle, 'entryTime');
};
export var contructYearMakeModel = function contructYearMakeModel(_ref2) {
  var _ref2$year = _ref2.year,
      year = _ref2$year === void 0 ? '' : _ref2$year,
      _ref2$make = _ref2.make,
      make = _ref2$make === void 0 ? '' : _ref2$make,
      _ref2$model = _ref2.model,
      model = _ref2$model === void 0 ? '' : _ref2$model;
  return year || make || model ? "".concat(year, " ").concat(make, " ").concat(model) : NO_DATA;
};
export var isTempVehicle = function isTempVehicle(vehicles) {
  return vehicles && !_isEmpty(vehicles.find(function (vehicle) {
    return vehicle.temp;
  }));
};
export var getVehiclesWithAge = function getVehiclesWithAge(vehicle) {
  return Math.floor(getVehicleAgeInDays(vehicle));
};
export var getStockID = function getStockID(vehcile) {
  return _get(vehcile || {}, 'stockID');
};
export var getYMM = function getYMM(vehicle) {
  return _pick(vehicle, ['year', 'make', 'model']);
};
export var getMileageInMiles = function getMileageInMiles(vehicle) {
  var mileageType = _get(vehicle, 'mileageType') || MILEAGE_TYPES.MILES;
  var mileage = getNumber(_get(vehicle, 'mileage'));

  if (mileage && mileageType === MILEAGE_TYPES.KM) {
    mileage /= KM_TO_MILES_CONVERTOR_FACTOR;
    mileage = Math.round(mileage);
  }

  return mileage;
};
export var getVehicleType = function getVehicleType(vehicle) {
  return _get(vehicle, 'vehicleType');
};
export var isVehicleCertified = function isVehicleCertified(vehicle) {
  return getVehicleType(vehicle) === VEHICLE_TYPE.USED && _get(vehicle, 'certified');
};
export var isVehicleDealerCertified = function isVehicleDealerCertified(vehicle) {
  return getVehicleType(vehicle) === VEHICLE_TYPE.USED && _get(vehicle, 'dealerCertified');
};
export var getBodyStyle = function getBodyStyle(vehicle) {
  return _get(vehicle, 'bodyType') || _get(vehicle, 'trimDetails.bodyType');
};
export var getBodyClass = function getBodyClass(vehicle) {
  return _get(vehicle, 'bodyClass') || _get(vehicle, 'trimDetails.bodyClass');
};
export var getNoOfEngineCylinders = function getNoOfEngineCylinders(vehicle) {
  return getNumber(_get(vehicle, 'trimDetails.engineCylinders') || 0);
};
export var getTrimDetails = function getTrimDetails(vehicle) {
  return _get(vehicle, 'trimDetails');
};
export var getOptions = function getOptions(vehicle) {
  return _get(vehicle, 'options');
};
export var getTrimValuesWithSpaceSeparator = function getTrimValuesWithSpaceSeparator(trimDetails) {
  var trimValues = _compact(_values(trimDetails));

  return trimValues.join(' ');
};
export var getTrimCode = function getTrimCode(vehicle) {
  var trimDetails = getTrimDetails(vehicle) || EMPTY_OBJECT;
  return getTrimValuesWithSpaceSeparator(trimDetails);
};
export var getOptionsCodeWithCommaSeperator = function getOptionsCodeWithCommaSeperator(vehicle) {
  var options = getOptions(vehicle) || EMPTY_ARRAY;

  var optionsCodes = _compact(options.map(function (option) {
    return _get(option, 'optionCode');
  }));

  return optionsCodes.join(' ,');
}; // export const getSortKeys = (key) => {
//   if (VEHICLE_SEARCH_KEYS[key]) {
//     return VEHICLE_SEARCH_KEYS[key];
//   }
//   return key;
// };

export var getVehicleInventoryURL = function getVehicleInventoryURL(vehicle) {
  var id = _get(vehicle, 'id');

  var basePath = TEnvReader.cmdsUrl(process.env);
  return "".concat(basePath, "vi/vehicle/").concat(id);
};
export var getVehicleGLAccountNumber = function getVehicleGLAccountNumber(vehicle) {
  return _get(vehicle, 'glAccountNumber');
};
export var getGLBalanace = function getGLBalanace(vehicle) {
  return _get(vehicle, 'pricingDetails.glBalance');
};
export var getGLAccount = function getGLAccount(vehicle) {
  return _get(vehicle, 'pricingDetails.glAccount');
};
export var getMSRP = function getMSRP(vehicle) {
  return _get(vehicle, ['pricingDetails', 'msrp']);
};
export var getExteriorColor = function getExteriorColor(vehicle) {
  return _get(vehicle, ['exteriorColor']);
};
export var getIsExistingStockId = function getIsExistingStockId(vehicle) {
  return _get(vehicle, ['isExistingStockId']);
};
export var getCostAdjustments = function getCostAdjustments(vehicle) {
  return _get(vehicle, ['costAdjustments']);
};
export var getOptionsForMake = _memoize(function (makes) {
  return _map(_uniqBy(makes), function (make) {
    return {
      label: _startCase(make),
      value: make
    };
  });
});
export var getOptionsForModel = function getOptionsForModel(models, year, make, value) {
  if (value) return [{
    label: value,
    value: value
  }];
  return _map(_filter(_get(models, make), function (modelDetail) {
    return modelDetail.year === getNumber(year);
  }), function (_ref3) {
    var displayModel = _ref3.displayModel,
        model = _ref3.model;
    return {
      label: displayModel,
      value: model
    } || [];
  });
};
export var getOptionsForLocations = function getOptionsForLocations(locations, selectedLocation) {
  var allLocations = _compact([selectedLocation].concat(_toConsumableArray(locations)));

  return _uniqBy(allLocations).map(function (code) {
    return {
      label: code,
      value: code
    };
  });
};
export var getUnladenWeight = function getUnladenWeight(vehicle) {
  var unladenWeight = _get(vehicle, 'unladenWeight') || 0;
  return "".concat(unladenWeight, " ").concat(_get(vehicle, 'unladenWeightUnit') || 'LBS');
};
export var getGrossWeight = function getGrossWeight(vehicle) {
  var grossWt = _get(vehicle, 'grossWeight') || 0;
  return "".concat(grossWt, " ").concat(_get(vehicle, 'grossWeightUnit') || 'LBS');
};

var hasValidCostCenter = function hasValidCostCenter(operations) {
  return _every(operations, function (operation) {
    return !_isEmpty(_get(operation, 'costCenters'));
  });
};
/**
 * OpenRO Price should only be sum of INTERNAL_PAY jobs
 * with operations which have a costCenter
 * @param {*} data
 */


export var getOpenROPrice = function getOpenROPrice(data) {
  var jobs = data.jobs;

  var totalInternalPrice = _reduce(_filter(jobs, function (_ref4) {
    var payType = _ref4.payType,
        status = _ref4.status,
        operations = _ref4.operations;
    return hasValidCostCenter(operations) && payType === 'INTERNAL' && isValidJob(status);
  }), function (total, _ref5) {
    var id = _ref5.id;
    var jobTotal = _get(data[id], 'amount') || 0;
    return total + jobTotal;
  }, 0);

  return formatROPrice(totalInternalPrice);
};
export var formatROPrice = function formatROPrice(price) {
  return _isNumber(price) ? price / 100 : price;
};
export var isPDIDone = function isPDIDone() {
  var vehicle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT;
  var roDetails = vehicle.roDetails;

  var pdiJobs = _reduce(roDetails, function (pdis, _ref6) {
    var pdiJobDetail = _ref6.pdiJobDetail;
    return [].concat(_toConsumableArray(pdis), _toConsumableArray(pdiJobDetail || EMPTY_ARRAY));
  }, []);

  return !_isEmpty(pdiJobs);
};
export var getOpenRecall = function getOpenRecall() {
  var vehicle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT;
  var roDetails = vehicle.roDetails,
      recallDetails = vehicle.recallDetails;

  var recallJobs = _reduce(roDetails, function (recalls, _ref7) {
    var recallJobDetails = _ref7.recallJobDetails;
    return [].concat(_toConsumableArray(recalls), _toConsumableArray(recallJobDetails || EMPTY_ARRAY));
  }, []);

  return _filter(recallDetails, function (recall) {
    var recallWithRO = _find(recallJobs, function (_ref8) {
      var recallNumber = _ref8.recallNumber;
      return recallNumber === _get(recall, 'manufacturerRecallNumber');
    });

    return _isEmpty(recallWithRO);
  });
};
export var getAllPDIs = function getAllPDIs() {
  var vehicle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT;
  return _get(vehicle, 'pdiDetails') || [];
};
export var getSumOfAllBodyPrices = function getSumOfAllBodyPrices(vehicle) {
  var pricingDetails = _get(vehicle, ['pricingDetails']);

  var additionalBodyParts = _get(pricingDetails, 'additionalBodyParts') || [];
  return additionalBodyParts.reduce(function (acc, additionalBodyPart) {
    return acc + (additionalBodyPart.bodyPrice || 0);
  }, 0);
};
export var getInvoicePrice = function getInvoicePrice(vehicle) {
  return _get(vehicle, ['pricingDetails', 'invoicePrice']);
};
export var getEmployeePrice = function getEmployeePrice(vehicle) {
  return _get(vehicle, ['pricingDetails', 'employeePrice']);
};
export var getSupplierPrice = function getSupplierPrice(vehicle) {
  return _get(vehicle, ['pricingDetails', 'supplierPrice']);
};
export var getWholeSalePrice = function getWholeSalePrice(vehicle) {
  return _get(vehicle, ['pricingDetails', 'wholesalePrice']);
};
export var getCommissionPrice = function getCommissionPrice(vehicle) {
  return _get(vehicle, ['pricingDetails', 'commissionPrice']);
};
export var getInternetPrice = function getInternetPrice(vehicle) {
  return _get(vehicle, ['pricingDetails', 'internetPrice']);
};
export var getListPrice = function getListPrice(vehicle) {
  var vehicleType = getVehicleType(vehicle);
  var listPrice = getRetailPrice(vehicle);

  if (vehicleType === VEHICLE_TYPE.NEW) {
    listPrice = getMSRP(vehicle);
  }

  var sumOfAllBodyPrices = getSumOfAllBodyPrices(vehicle);

  if (listPrice === 0 || sumOfAllBodyPrices === 0) {
    return 0;
  }

  listPrice += sumOfAllBodyPrices;
  return listPrice;
};
export var getSelectedVehiclePayload = function getSelectedVehiclePayload(vehicle) {
  var vehiclePayload = {};
  vehiclePayload = _pick(vehicle, ['id', 'vin', 'status', 'leadId', 'vehicleType', 'stockID']);
  vehiclePayload.glAccountNumber = _get(vehicle, 'accountNumber');
  vehiclePayload.glAccountId = _get(vehicle, 'accountId');
  vehiclePayload.viOptions = _get(vehicle, 'options');
  return vehiclePayload;
};
export var getVehicleIcon = function getVehicleIcon(vehicle) {
  return _get(vehicle, 'thumbnailIcon.url') ? _get(vehicle, 'thumbnailIcon.url', EMPTY_STRING) : _get(vehicle, 'iconDetail.thumbnailUrl', EMPTY_STRING);
};
export var getOptionsForVIOptions = _memoize(function (viOptions) {
  return _map(_uniqBy(viOptions), function (option) {
    return {
      label: option,
      value: option
    };
  });
});
export var getQualifiedForNewVehiclePrograms = function getQualifiedForNewVehiclePrograms(vehicle) {
  return _get(vehicle, 'qualifiedForNewVehiclePrograms');
};
export var getVehicleStockedInAtSite = function getVehicleStockedInAtSite(vehicle) {
  return _get(vehicle, 'stockedInAtSiteId');
};